module.exports = __webpack_public_path__ + "static/media/insect(34).a5294775.PNG";